import './timer.js'

const broadcast = new BroadcastChannel('timers');

window.timers = {
    findTimers(task_id) {
        return document.querySelectorAll(`task-timer[data-task="${task_id}"]`);
    },
    requestStopCurrentTimer() {
        return axios.post('/admin/timer/stop')
            .then(r => r.data)
            .then(timers => {
                this.updateTimers(timers)
                broadcast.postMessage({
                    method: 'updateTimers',
                    arguments: [timers]
                });
            })
    },
    requestStartTimerFor(task_id) {
        return axios.post('/admin/timer/start', {
            task_id
        })
            .then(r => r.data)
            .then(timers => {
                this.updateTimers(timers);
                broadcast.postMessage({
                    method: 'updateTimers',
                    arguments: [timers]
                });
            })
    },
    requestFinish(task_id) {
        axios.post('/admin/timer/finish', {
            task_id
        })
            .then(r => r.data)
            .then(timers => {
                this.afterFinish(timers, task_id)
                broadcast.postMessage({
                    method: 'afterFinish',
                    arguments: [timers, task_id]
                });
            })
    },
    afterFinish(timers, task_id) {
        this.updateTimers(timers);
        document.querySelector(`#timer_${task_id}`)?.remove();

        if(timers[0].task_id === task_id) {
            this.updateHeader(null);
        }
    },
    updateHeader(timerInfo) {
        /**
         * @type {HTMLElement}
         */
        const headerTimer = document.querySelector('#headerTimer');
        /**
         * @type {HTMLElement}
         */
        const headerTask = document.querySelector('#headerTask');
        if(timerInfo) {
            headerTimer.setAttribute('data-task', timerInfo.task_id);
            headerTimer.setAttribute('data-seconds', timerInfo.seconds);
            headerTimer.setAttribute('data-estimated', timerInfo.estimated_seconds);
            headerTimer.setAttribute('data-working-since', timerInfo.working_since);
            headerTimer.style.display = '';

            headerTask.href = timerInfo.task.links.preview;
            headerTask.textContent = `[#${timerInfo.task_id}] ${timerInfo.task.name}`;
            headerTask.style.display = '';
        } else {
            headerTimer.style.setProperty('display', 'none', 'important');
            headerTask.style.setProperty('display', 'none', 'important');
        }
    },
    updateTimers(timersResponse) {
        let headerUpdated = false;
        for(let timerInfo of timersResponse) {
            const timerElements = this.findTimers(timerInfo.task_id)
            for(let timerEl of timerElements) {
                timerEl.setAttribute('data-working-since', timerInfo.working_since);
                timerEl.setAttribute('data-seconds', timerInfo.seconds);
            }

            if(!headerUpdated) {
                this.updateHeader(timerInfo);
                headerUpdated = true;
            }
        }
    }
}

broadcast.onmessage = function(event) {
    console.log(event.data);
    if('method' in event.data) {
        const args = event.data.arguments ?? [];
        window.timers[event.data.method](...args);
    }
}
